import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const KYC_DELETE_CONFIRM = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'KYC_DELETE_CONFIRM')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(callAPI({
      dispatch: dispatch,
      endpoint: 'test.json',
      requestAction: KYC_DELETE_CONFIRM.INIT_REQUEST,
      successAction: KYC_DELETE_CONFIRM.INIT_SUCCESS,
      success: function(result) {}
    }))
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [KYC_DELETE_CONFIRM.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [KYC_DELETE_CONFIRM.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'kycDeleteConfirm',
    reducerMap: {
      kycDeleteConfirmState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
